import Vue from "vue";
import Router from "vue-router";
// import utils from '../common/cookieUtils'
import { cookies } from "@/common/cookieUtils";
import { Message } from "iview";
// import productBox from "@/components/products/product-box";
import httpRequestEntrance from "../common/httpRequestEntrance.js";

let staticRouter = [];
//默认路由 等待 与动态路由合并
let defaultRouter = {
  path: '/',
  name: 'index',
  meta: {
    title: '招商云-金融云安全专家',
  },
  component: () => import('@/components/index'),
  children: []
}
Vue.use(Router);

//处理点击跳转当前路由报错
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const createRouter = () =>
  new Router({
    routes: staticRouter,
    scrollBehavior: () => ({
      // 滚动条滚动的行为，不加这个默认就会记忆原来滚动条的位置
      y: 0
    })
  });

const router = createRouter();

function getDynamicRoutes() {
  return httpRequestEntrance.httpRequestEntrance(
    "GET",
    "/v1/cloud/auto_top_catalogs",
    "",
    resData => {
      let routerTemp = [];
      let topMenu = resData;
      let concatArr = topMenu.header_data.concat(topMenu.footer_data);
      concatArr.forEach(element => {
        if (element.classify_group && element.classify_group.length) {
          element.classify_group.forEach(item => {
            if (
              item.auto_classify_catalog &&
              item.auto_classify_catalog.length
            ) {
              item.auto_classify_catalog.forEach(it => {
                if (it.auto_product_catalog && it.auto_product_catalog.length) {
                  it.auto_product_catalog.forEach(pro_item => {
                    if (
                      pro_item.is_inner &&
                      pro_item.link &&
                      !pro_item.is_static_html
                    ) {
                      let url = pro_item.link;
                      if (pro_item.link.includes("/#/"))
                        url = pro_item.link.substr(
                          pro_item.link.indexOf("/#/") + 3
                        );
                      routerTemp.push({ url: url, id: pro_item.id });
                    }
                  });
                }
              });
            }
          });
        } else {
          if (
            element.auto_classify_catalog &&
            element.auto_classify_catalog.length
          ) {
            element.auto_classify_catalog.forEach(item => {
              if (
                item.auto_product_catalog &&
                item.auto_product_catalog.length
              ) {
                item.auto_product_catalog.forEach(it => {
                  if (it.is_inner && it.link && !it.is_static_html) {
                    let url = it.link;
                    if (it.link.includes("/#/"))
                      url = it.link.substr(it.link.indexOf("/#/") + 3);
                    routerTemp.push({ url: url, id: it.id });
                  }
                });
              }
            });
          }
        }
      });
      let routerArr = routerTemp.map(item => {
        return {
          path: item.url,
          name: item.url,
          meta: { productId: item.id },
          // component: productBox,
          title: "招商云"
        };
      });
      return routerArr;
    }
  );
}

function $Message(content) {
  Message.info({
    content: content,
    duration: 5,
    closable: true
  });
}

async function createRoutes() {
  let dynamicRouters = await getDynamicRoutes();
  defaultRouter.children = defaultRouter.children.concat(dynamicRouters);
  return [
    defaultRouter,
    {
      path: "*",
      name: "page404",
      // component: () => import("@/components/page404"),
      title: "招商云"
    }
  ];
}

let hasMenus = false;
router.beforeEach(async (to, from, next) => {
  //拉取动态路由
  if (!hasMenus) {
    hasMenus = true;
    let temp = await createRoutes();
    router.addRoutes(temp);
    if (!to.name) {
      //处理刷新
      next({ name: to.path.substring(1) });
    }
  }
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否需要登录权限
    cookies.getAuthorization().then(token => {
      if (!token) {
        next({
          name: "login",
          params: { from: to.name, params: to.params }
        });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   utils.setTitle(to.meta.title)
  // }
  let helpList = {
    vpsOperate: "ecs",
    physicalModel: "bms",
    cdhOperate: "cdh",
    wadOperate: "cbs",
    nasBuyWord: "nas",
    ossOperate: "oss",
    mysqlBackup: "mysqlBackup",
    slbOperate: "slb",
    vipOperate: "vip",
    ipOperate: "ip",
    eipOperate: "eip",
    cdnOperate: "cdn",
    natOperate: "nat",
    vpcOperate: "vpc",
    fwOperate: "firewall",
    dnsOperate: "dns",
    cloudMysql: "cloudMySQL",
    cloudOracle: "cloudOracle",
    cloudRedis: "cloudRedis",
    cloudMongo: "cloudMongo",
    cdtc: "cdtc",
    cdts: "cdts",
    mirrorsOperate: "mirrors",
    privacyProtocol: "law",
    whitepaper: "whitepaper",
    coludBastion: "cloudBastion",
    visualEditOperate: "visualEdit",
    PublicCloud: "PublicCloud"
  };
  let newpath = helpList[to.path.slice(1)];
  if (newpath) {
    window.location.href =
      location.origin + "/docs/" + newpath + "/manual.html";
  } else {
    next();
  }
});
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  // const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    // router.replace(targetPath)
    $Message("系统更新，页面将进行刷新操作！");
    window.location.reload();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js